import React from "react";
import { CreditCard, Heart } from "lucide-react";
import { FlutterWaveButton as FWButton } from "flutterwave-react-v3";

// FlutterWave Button Component (for sidebar)
export const FlutterWaveButton = ({ config, onSuccess, onClose, donorEmail, donationAmount }) => {
  if (!donationAmount || !donorEmail) {
    return (
      <button 
        className="w-full bg-white text-[#0085FF] hover:bg-gray-100 px-6 py-4 rounded-xl font-semibold transition-colors inline-flex items-center justify-center gap-2 opacity-50 cursor-not-allowed"
        disabled
      >
        <CreditCard className="w-5 h-5" />
        Pay with Flutterwave
      </button>
    );
  }
  
  return (
    <FWButton
      public_key={config.public_key}
      tx_ref={config.tx_ref}
      amount={donationAmount}
      currency={config.currency}
      payment_options={config.payment_options}
      customer={{
        ...config.customer,
        email: donorEmail,
      }}
      customizations={config.customizations}
      meta={config.meta}
      callback={(response) => {
        onSuccess(response);
      }}
      onclose={() => {
        onClose();
      }}
      text="Pay with Flutterwave"
      className="w-full bg-white text-[#0085FF] hover:bg-gray-100 px-6 py-4 rounded-xl font-semibold transition-colors inline-flex items-center justify-center gap-2"
    />
  );
};

// Main Donate Now Button with FlutterWave
export const FlutterWaveButtonMain = ({ config, onSuccess, onClose, donorEmail, donationAmount }) => {
  if (!donationAmount || !donorEmail) {
    return (
      <button 
        className="w-full bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-full font-medium text-sm transition-colors inline-flex items-center justify-center gap-2 opacity-50 cursor-not-allowed"
        disabled
      >
        <Heart className="w-5 h-5" /> DONATE NOW
      </button>
    );
  }
  
  return (
    <FWButton
      public_key={config.public_key}
      tx_ref={config.tx_ref}
      amount={donationAmount}
      currency={config.currency}
      payment_options={config.payment_options}
      customer={{
        ...config.customer,
        email: donorEmail,
      }}
      customizations={config.customizations}
      meta={config.meta}
      callback={(response) => {
        onSuccess(response);
      }}
      onclose={() => {
        onClose();
      }}
      text="DONATE NOW"
      className="w-full bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-full font-medium text-sm transition-colors inline-flex items-center justify-center gap-2"
    />
  );
};
